<div class="error-wrapper">
  <div class="error">
    <div class="logo__error">
      <img src="assets/images/logo.svg">
    </div>

    <div class="error__inner">
      <div class="icon-wrapper">
        <i class="fal fa-exclamation-circle" style="font-size: 65px;"></i>
      </div>
      <h1>You are not signed in!</h1>
      <p>You are signed out from current browser. Please sign back in to continue.</p>
      <!-- <p><a routerLink="/login" class="error-btn">Sign In</a></p> -->
      <p><a (click)="onLogin()" class="error-btn">Sign In</a></p>
    </div>
  </div>
</div>
